// const { toJson } = require("angular");

angular.module('tgaAdmin')
  .service('translationTemplateService',
    function () {
      this.generateCSV = function (game, gameTranslations) {
        const csvData = [];
        // loop through available translations and create headers
        const csvHeader = ['', 'Default Language'];

        const allTranslations = angular.copy(gameTranslations);

        delete allTranslations[game.language_id];

        const translationKeys = Object.keys(allTranslations);

        for (let i = 0; i < translationKeys.length; i++) {
          const key = translationKeys[i];
          const translation = gameTranslations[key];
          const headerString = `${translation.name} [${translation.language_id}]`;
          csvHeader.push(headerString);
        }
        csvData.push(csvHeader);

        let rowData = [];

        // Add splash and pop data
        if (game.splash.logo.text) {
          rowData = [];

          rowData.push('Splash logo text');
          rowData.push(game.splash.logo.text);

          for (let i = 0; i < translationKeys.length; i++) {
            const key = translationKeys[i];
            const translations = game.translations[key];

            if (!translations) {
              rowData.push(null);
            } else {
              rowData.push(translations.splash.logo.text);
            }
          }

          csvData.push(rowData);
        }

        if (game.splash.title.text) {
          rowData = [];

          rowData.push('Splash title text');
          rowData.push(game.splash.title.text);

          for (let i = 0; i < translationKeys.length; i++) {
            const key = translationKeys[i];
            const translations = game.translations[key];

            if (!translations) {
              rowData.push(null);
            } else {
              rowData.push(translations.splash.title.text);
            }
          }

          csvData.push(rowData);
        }

        if (game.popup.title) {
          rowData = [];

          rowData.push('Popup title text');
          rowData.push(game.popup.title);

          for (let i = 0; i < translationKeys.length; i++) {
            const key = translationKeys[i];
            const translations = game.translations[key];

            if (!translations) {
              rowData.push(null);
            } else {
              rowData.push(translations.popup.title);
            }
          }

          csvData.push(rowData);
        }

        if (game.popup.body) {
          rowData = [];

          rowData.push('Popup body text');
          rowData.push(game.popup.body);

          for (let i = 0; i < translationKeys.length; i++) {
            const key = translationKeys[i];
            const translations = game.translations[key];

            if (!translations) {
              rowData.push(null);
            } else {
              rowData.push(translations.popup.body);
            }
          }

          csvData.push(rowData);
        }

        // loop through questions to create rows`
        const parseQuestionIntoRow = (question, questionIndex) => {
          rowData = [];

          let questionString = `Question ${questionIndex + 1}`;

          if (question.question_type === 'interstitial') {
            questionString = `Interstitial ${questionIndex + 1}`;
          } else if (question.question_type === 'grid') {
            questionString = `Grid ${questionIndex + 1}`;
          }

          rowData.push(questionString);

          if (question.translations) {
            rowData.push(question.text);

            for (let j = 0; j < translationKeys.length; j++) {
              const key = translationKeys[j];

              if (question.translations[key]) {
                rowData.push(question.translations[key].text);
              } else {
                rowData.push(null);
              }
            }
          }

          csvData.push(rowData);

          // Grid row/column titles
          if (question.question_type === 'grid') {
            for (let x = 0; x < question.row_titles.length; x++) {
              const row = question.row_titles[x];
              const titleString = `Row ${x + 1} Title`;
              rowData = [];
              rowData.push(titleString);
              rowData.push(row.text);

              for (let k = 0; k < translationKeys.length; k++) {
                const key = translationKeys[k];

                if (question.translations[key] && question.translations[key].row_titles) {
                  rowData.push(question.translations[key].row_titles[x].text);
                } else {
                  rowData.push(null);
                }
              }

              csvData.push(rowData);
            }

            for (let x = 0; x < question.column_titles.length; x++) {
              const column = question.column_titles[x];
              const titleString = `Column ${x + 1} Title`;
              rowData = [];
              rowData.push(titleString);
              rowData.push(column.text);

              for (let k = 0; k < translationKeys.length; k++) {
                const key = translationKeys[k];

                if (question.translations[key] && question.translations[key].column_titles) {
                  rowData.push(question.translations[key].column_titles[x].text);
                } else {
                  rowData.push(null);
                }
              }

              csvData.push(rowData);
            }
          }

          if (question.answer_phrase) {
            rowData = [];
            rowData.push('Opening phrase');
            rowData.push(question.answer_phrase);

            for (let j = 0; j < translationKeys.length; j++) {
              const key = translationKeys[j];

              if (question.translations[key]) {
                rowData.push(question.translations[key].answer_phrase);
              } else {
                rowData.push(null);
              }
            }

            csvData.push(rowData);
          }

          const { answers } = question;

          for (let j = 0; j < answers.length; j++) {
            const answer = answers[j];

            if (question.question_type === 'grid') {
              for (let x = 0; x < answer.length; x++) {
                const tile = answer[x];
                const answerString = `Row ${j + 1} / Column ${x + 1}`;
                rowData = [];
                rowData.push(answerString);
                rowData.push(tile.text);

                for (let k = 0; k < translationKeys.length; k++) {
                  const key = translationKeys[k];
                  if (tile.translations && tile.translations[key]) {
                    rowData.push(tile.translations[key].text);
                  } else {
                    rowData.push(null);
                  }
                }

                csvData.push(rowData);
              }
            } else {
              const answerString = `Answer ${j + 1}`;
              rowData = [];
              rowData.push(answerString);
              rowData.push(answer.text);

              for (let k = 0; k < translationKeys.length; k++) {
                const key = translationKeys[k];
                if (answer.translations && answer.translations[key]) {
                  rowData.push(answer.translations[key].text);
                } else {
                  rowData.push(null);
                }
              }

              csvData.push(rowData);
            }
          }

          if (question.response_correct) {
            rowData = [];
            rowData.push('Feedback Correct');
            rowData.push(question.response_correct);

            for (let j = 0; j < translationKeys.length; j++) {
              const key = translationKeys[j];

              if (question.translations[key]) {
                rowData.push(question.translations[key].response_correct);
              } else {
                rowData.push(null);
              }
            }

            csvData.push(rowData);
          }

          if (question.response_incorrect) {
            rowData = [];
            rowData.push('Feedback Incorrect');
            rowData.push(question.response_incorrect);
            // rowData.push(question.response_incorrect_image);

            for (let j = 0; j < translationKeys.length; j++) {
              const key = translationKeys[j];

              if (question.translations[key]) {
                rowData.push(question.translations[key].response_incorrect);
                // rowData.push(question.translations[key].response_incorrect_image);
              } else {
                rowData.push(null);
                // rowData.push(null);
              }
            }

            csvData.push(rowData);
          }

          if (question.response_timeout) {
            rowData = [];
            rowData.push('Feedback Timeout');
            rowData.push(question.response_timeout);
            // rowData.push(question.response_timeout_image);

            for (let j = 0; j < translationKeys.length; j++) {
              const key = translationKeys[j];
              if (question.translations[key]) {
                rowData.push(question.translations[key].response_timeout);
                // rowData.push(question.translations[key].response_timeout_image);
              } else {
                rowData.push(null);
              }
            }

            csvData.push(rowData);
          }

          if (question.advanced_feedback) {
            question.advanced_feedback.forEach((feedback, index) => {
              const feedbackRowData = [];
              feedbackRowData.push(`Advanced Feedback Slide ${index + 1}`);
              feedbackRowData.push(feedback.text);
              for (let j = 0; j < translationKeys.length; j++) {
                const key = translationKeys[j];
                if (feedback.translations[key]) {
                  feedbackRowData.push(feedback.translations[key].text);
                } else {
                  feedbackRowData.push(null);
                }
              }
              csvData.push(feedbackRowData);
            });
          }
        };

        if (game.game_type === 'jeopardy') {
          for (let i = 0; i < game.question_groups.length; i++) {
            const round = game.question_groups[i];
            rowData = [];
            rowData.push(round.name);
            csvData.push(rowData);
            for (let ii = 0; ii < round.question_groups.length; ii++) {
              const category = round.question_groups[ii];
              rowData = [];
              if (category.translations) {
                rowData.push(`${round.name} / Category ${ii + 1} name`);
                rowData.push(category.name);
                for (let j = 0; j < translationKeys.length; j++) {
                  const key = translationKeys[j];
                  if (category.translations[key]) {
                    rowData.push(category.translations[key].text);
                  } else {
                    rowData.push(null);
                  }
                }
              }
              csvData.push(rowData);
              for (let k = 0; k < category.questions.length; k++) {
                const question = angular.copy(category.questions[k]);
                parseQuestionIntoRow(question, k);
              }
            }
          }
        } else {
          for (let i = 0; i < game.questions.length; i++) {
            const question = angular.copy(game.questions[i]);
            parseQuestionIntoRow(question, i);
          }
        }
        return csvData;
      };

      this.generateXLSX = function (game, gameTranslations) {
        const workbook = new ExcelJS.Workbook();
        workbook.creator = 'The Training Arcade';
        let worksheet;
        if (game.game_type === 'jeopardy') {
          worksheet = workbook.addWorksheet('Game Information');
        } else {
          worksheet = workbook.addWorksheet('Translation Temmplate');
        }
        const columns = [
          { header: '', key: 'title', width: 50 },
          { header: 'Default Language', key: 'col1', width: 20 },
        ];

        const allTranslations = angular.copy(gameTranslations);

        delete allTranslations[game.language_id];

        const translationKeys = Object.keys(allTranslations);

        for (let i = 0; i < translationKeys.length; i++) {
          const key = translationKeys[i];
          const translation = gameTranslations[key];
          if (translation) {
            const headerString = `${translation.name} [${translation.language_id}]`;
            columns.push({ header: headerString, key: `col${key}`, width: 20 });
          }
        }
        worksheet.columns = columns;

        let rowData = {};

        if (game.splash.logo.text) {
          rowData = {};

          rowData.title = 'Splash logo text';
          rowData.col1 = game.splash.logo.text;

          for (let i = 0; i < translationKeys.length; i++) {
            const key = translationKeys[i];
            const translations = game.translations[key];
            if (translations) {
              rowData[`col${key}`] = translations.splash.logo.text;
            }
          }

          worksheet.addRow(rowData);
        }

        if (game.splash.title.text) {
          rowData = {};

          rowData.title = 'Splash title text';
          rowData.col1 = game.splash.title.text;

          for (let i = 0; i < translationKeys.length; i++) {
            const key = translationKeys[i];
            const translations = game.translations[key];
            if (translations) {
              rowData[`col${key}`] = translations.splash.title.text;
            }
          }

          worksheet.addRow(rowData);
        }

        if (game.popup.title) {
          rowData = {};

          rowData.title = 'Popup title text';
          rowData.col1 = game.popup.title;
          for (let i = 0; i < translationKeys.length; i++) {
            const key = translationKeys[i];
            const translations = game.translations[key];
            if (translations) {
              rowData[`col${key}`] = translations.popup.title;
            }
          }

          worksheet.addRow(rowData);
        }

        if (game.popup.body) {
          rowData = {};

          rowData.title = 'Popup body text';
          rowData.col1 = game.popup.body;

          for (let i = 0; i < translationKeys.length; i++) {
            const key = translationKeys[i];
            const translations = game.translations[key];
            if (translations) {
              rowData[`col${key}`] = translations.popup.body;
            }
          }

          worksheet.addRow(rowData);
        }

        const parseQuestionIntoRow = (question, questionIndex, sheet) => {
          rowData = {};
          let questionString = `Question ${questionIndex + 1}`;

          if (question.question_type === 'interstitial') {
            questionString = `Interstitial ${questionIndex + 1}`;
          } else if (question.question_type === 'grid') {
            questionString = `Grid ${questionIndex + 1}`;
          }

          rowData.title = questionString;
          if (question.translations) {
            rowData.col1 = question.text;

            for (let j = 0; j < translationKeys.length; j++) {
              const key = translationKeys[j];
              if (question.translations[key]) {
                rowData[`col${key}`] = question.translations[key].text;
              }
            }
          }
          sheet.addRow(rowData);

          // Grid row/column titles
          if (question.question_type === 'grid') {
            for (let x = 0; x < question.row_titles.length; x++) {
              const row = question.row_titles[x];
              const titleString = `Row ${x + 1} Title`;
              rowData = {};
              rowData.title = titleString;
              rowData.col1 = row.text;

              for (let k = 0; k < translationKeys.length; k++) {
                const key = translationKeys[k];

                if (question.translations[key] && question.translations[key].row_titles) {
                  rowData[`col${key}`] = question.translations[key].row_titles[x].text;
                }
              }

              sheet.addRow(rowData);
            }

            for (let x = 0; x < question.column_titles.length; x++) {
              const column = question.column_titles[x];
              const titleString = `Column ${x + 1} Title`;
              rowData = {};
              rowData.title = titleString;
              rowData.col1 = column.text;

              for (let k = 0; k < translationKeys.length; k++) {
                const key = translationKeys[k];
                if (question.translations[key] && question.translations[key].column_titles) {
                  rowData[`col${key}`] = question.translations[key].column_titles[x].text;
                }
              }
              sheet.addRow(rowData);
            }
          }

          if (question.answer_phrase) {
            rowData = {};
            rowData.title = 'Opening phrase';
            rowData.col1 = question.answer_phrase;
            for (let j = 0; j < translationKeys.length; j++) {
              const key = translationKeys[j];
              if (question.translations[key]) {
                rowData[`col${key}`] = question.translations[key].answer_phrase;
              }
            }
            sheet.addRow(rowData);
          }

          const { answers } = question;

          for (let j = 0; j < answers.length; j++) {
            const answer = answers[j];

            if (question.question_type === 'grid') {
              for (let x = 0; x < answer.length; x++) {
                const tile = answer[x];
                const answerString = `Row ${j + 1} / Column ${x + 1}`;
                rowData = {};
                rowData.title = answerString;
                rowData.col1 = tile.text;

                for (let k = 0; k < translationKeys.length; k++) {
                  const key = translationKeys[k];
                  if (tile.translations && tile.translations[key]) {
                    rowData[`col${key}`] = tile.translations[key].text;
                  }
                }
                sheet.addRow(rowData);
              }
            } else {
              const answerString = `Answer ${j + 1}`;
              rowData = {};
              rowData.title = answerString;
              rowData.col1 = answer.text;

              for (let k = 0; k < translationKeys.length; k++) {
                const key = translationKeys[k];
                if (answer.translations && answer.translations[key]) {
                  rowData[`col${key}`] = answer.translations[key].text;
                }
              }

              sheet.addRow(rowData);
            }
          }

          if (question.response_correct) {
            rowData = {};
            rowData.title = 'Feedback Correct';
            rowData.col1 = question.response_correct;
            for (let j = 0; j < translationKeys.length; j++) {
              const key = translationKeys[j];
              if (question.translations[key]) {
                rowData[`col${key}`] = question.translations[key].response_correct;
              }
            }
            sheet.addRow(rowData);
          }

          if (question.response_incorrect) {
            rowData = {};
            rowData.title = 'Feedback Incorrect';
            rowData.col1 = question.response_incorrect;

            for (let j = 0; j < translationKeys.length; j++) {
              const key = translationKeys[j];
              if (question.translations[key]) {
                rowData[`col${key}`] = question.translations[key].response_incorrect;
              }
            }
            sheet.addRow(rowData);
          }

          if (question.response_timeout) {
            rowData = {};
            rowData.title = 'Feedback Timeout';
            rowData.col1 = question.response_timeout;
            for (let j = 0; j < translationKeys.length; j++) {
              const key = translationKeys[j];
              if (question.translations[key]) {
                rowData[`col${key}`] = question.translations[key].response_timeout;
              }
            }
            sheet.addRow(rowData);
          }

          if (question.advanced_feedback) {
            question.advanced_feedback.forEach((feedback, index) => {
              rowData = {};
              rowData.title = `Advanced Feedback (${index})`;
              rowData.col1 = feedback.text;
              for (let j = 0; j < translationKeys.length; j++) {
                const key = translationKeys[j];
                if (feedback.translations && feedback.translations[key]) {
                  rowData[`col${key}`] = feedback.translations[key].text;
                }
              }
              sheet.addRow(rowData);
            });
          }
        };

        // loop through questions to create rows
        if (game.game_type === 'jeopardy') {
          for (let i = 0; i < game.question_groups.length; i++) {
            const round = game.question_groups[i];
            rowData = {};
            rowData.title = round.name;
            worksheet.addRow(rowData);
            for (let ii = 0; ii < round.question_groups.length; ii++) {
              const category = round.question_groups[ii];
              rowData = {};
              if (category.translations) {
                rowData.title = `${round.name} / Category ${ii + 1} name`;
                rowData.col1 = category.name;
                for (let j = 0; j < translationKeys.length; j++) {
                  const key = translationKeys[j];
                  if (category.translations[key]) {
                    rowData[`col${key}`] = category.translations[key].text;
                  }
                }
              }
              worksheet.addRow(rowData);
              for (let k = 0; k < category.questions.length; k++) {
                const question = angular.copy(category.questions[k]);
                parseQuestionIntoRow(question, k, worksheet);
              }
            }
          }
        } else {
          for (let i = 0; i < game.questions.length; i++) {
            const question = angular.copy(game.questions[i]);
            parseQuestionIntoRow(question, i, worksheet);
          }
        }
        return workbook;
      };
    });
